"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientShortcutManager = void 0;
var tslib_1 = require("tslib");
var client_command_1 = require("../../base/commands/client-command");
var shortcut_manager_1 = require("../../base/commands/shortcut-manager");
var key_1 = require("@devexpress/utils/lib/utils/key");
var ClientShortcutManager = (function (_super) {
    tslib_1.__extends(ClientShortcutManager, _super);
    function ClientShortcutManager(commandManager, control) {
        var _this = _super.call(this, commandManager, control) || this;
        _this.createShortcut(commandManager, client_command_1.RichEditClientCommand.CreateNewDocumentLocally, [key_1.ModifierKey.Ctrl | key_1.KeyCode.Key_n], [key_1.ModifierKey.Meta | key_1.KeyCode.Key_n]);
        _this.createShortcut(commandManager, client_command_1.RichEditClientCommand.OpenDocumentLocally, [key_1.ModifierKey.Ctrl | key_1.KeyCode.Key_o, key_1.ModifierKey.Ctrl | key_1.KeyCode.F12], [key_1.ModifierKey.Meta | key_1.KeyCode.Key_o]);
        _this.createShortcut(commandManager, client_command_1.RichEditClientCommand.ExportDocument, [key_1.ModifierKey.Ctrl | key_1.KeyCode.Key_s], [key_1.ModifierKey.Meta | key_1.KeyCode.Key_s]);
        _this.createShortcut(commandManager, client_command_1.RichEditClientCommand.PrintDocumentOnClient, [key_1.ModifierKey.Ctrl | key_1.KeyCode.Key_p], [key_1.ModifierKey.Meta | key_1.KeyCode.Key_p]);
        return _this;
    }
    return ClientShortcutManager;
}(shortcut_manager_1.ShortcutManager));
exports.ClientShortcutManager = ClientShortcutManager;
